module.exports = __webpack_public_path__ + "img/nginx-booth-video.054e2da4.png";